











































































import { computed, defineComponent, nextTick, onMounted, getCurrentInstance } from '@vue/composition-api';
import { PlayCircleStrokeIcon } from 'tdesign-icons-vue';
import i18n, { i18n_t } from '@/locales/i18n';

// 引入 compositions
import { SettingTab } from '@/renderer/components/dialog/setting/SettingConst';
import sidebarGuideHandler from '@/renderer/views/desktop/BaseSidebar/SidebarGuideHandler';

// 引入工具类
import { getOfficialWebsiteUrl } from '@/renderer/scripts/utils/tools/index';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { startGuideSteps } from '@/renderer/scripts/utils/GuideHelper';
import ipc from '@/renderer/scripts/utils/ipc';
import { RoleMap } from '@/renderer/scripts/utils/ConstantConfig';
import { httpUrl } from '@/renderer/scripts/http';
import { IS_BROWSER } from '@/common/constant/platform';

import NoviceGuideCards from './NoviceGuideCards.vue';
import guideHandler from '../composition/guideHandler';

type IntroSection = {
  id: string;
  title: string;
  icon: string;
  introduce: string;
  text?: string;
};
export default defineComponent({
  name: 'AdvanceDialog',
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
    advanceGuideCardId: {
      required: true,
      type: Number,
      default: 0,
    },
  },
  components: {
    NoviceGuideCards,
    PlayCircleStrokeIcon,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const store = context.root.$store;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const detailList = [
      {
        title: i18n_t('助力企业安全管理'),
        sections: [
          {
            title: i18n_t('轻松管理企业员工'),
            id: 'guide_003',
            icon: 'advanceGuide-step-1',
            introduce: `${
              !store.getters.isPrivate
                ? `${i18n_t('如何进行企业成员初始化设置？')}<br/>
                   ${i18n_t('如何关联企微、IDaas组织架构？')}<br/>
                   ${i18n_t('如何手机号批量导入成员？')}`
                : `${i18n_t('进行企业成员初始化设置')}<br/>${i18n_t('根据手机号批量导入成员')}`
            }`,
          },
          {
            title: i18n_t('安全管理企业资产'),
            id: 'guide_004',
            icon: 'advanceGuide-step-2',
            introduce: `${
              !store.getters.isPrivate
                ? `${i18n_t('如何查看用户行为日志？')}<br/>
                   ${i18n_t('如何设置安全链接和云查杀？')}<br/>
                   ${i18n_t('如何自定义企业安全水印？')}`
                : `${i18n_t('查看用户行为日志')}<br/>${i18n_t('自定义企业安全水印')}`
            }`,
          },
          {
            title: i18n_t('全面便捷数据统计'),
            id: 'guide_005',
            icon: 'advanceGuide-step-3',
            introduce: `${
              !store.getters.isPrivate
                ? `${i18n_t('快速查看企业网盘使用情况')}<br/>
                   ${i18n_t('查看企业用户账号规格情况')}<br/>
                   ${i18n_t('查看个人、团队、外网流量情况')}`
                : `${i18n_t('快速查看企业网盘使用情况')}<br/>${i18n_t('查看企业用户账号规格情况')}`
            }`,
          },
        ],
      },
      {
        title: i18n_t('助力员工高效工作'),
        sections: [
          {
            title: i18n_t('多端资料同步，加密分享'),
            introduce: i18n_t('办公资料上传到网盘，可随时查看；交付方案支持密码、水印等多种加密方式分享'),
            icon: 'guide-step-4',
          },
          {
            title: i18n_t('和同事一起协作'),
            introduce: i18n_t('邀请同事成为共享空间的成员，你们可以一起管理资料{slot1}', {
              slot1: !store.getters.isPrivate ? i18n_t('，在线编辑办公文档') : '',
            }),
            icon: 'guide-step-3',
          },
        ],
      },
      {
        title: i18n_t('腾讯电子签'),
        introduce: i18n_t(
          '腾讯电子签是一款为企业及个人提供安全、便捷的电子合同签约及证据保存服务的产品。在腾讯云企业网盘中，您可以直接基于网盘中已有文件快速发起电子合同，高效锁定客户。签署后文件自动归档到腾讯云企业网盘，安全可溯。',
        ),
        sections: [
          {
            title: i18n_t('方便快捷、合规有效、轻松管理'),
            icon: 'advanceGuide-icon-1',
            text: i18n_t('网盘文件直接签署，快捷高效；真实意愿验证，内容不可篡改；合同线上归档，支持小程序查看'),
          },
          {
            title: i18n_t('降本增效、安全可靠、签署线上化'),
            icon: 'advanceGuide-icon-2',
            text: i18n_t('降低合同签署成本；全程区块链存证，保障合作权益；无惧疫情，全程远程签署。'),
          },
        ],
        btnText: i18n_t('立即体验'),
      },
      {
        title: i18n_t('企业网盘防勒索能力'),
        introduce: '',
        sections: [
          {
            title: i18n_t('防范于未然——事前风险嗅探'),
            icon: 'advanceGuide-icon-1',
            text: i18n_t('通过腾讯安全能力植入，进行蜜罐感知监控，实施监控勒索病毒文件的批量操作行为，防范于未然'),
          },
          {
            title: i18n_t('资产守护方案——事中安全备份'),
            icon: 'advanceGuide-icon-2',
            text: i18n_t('通过部署数据备份系统及开启同步备份能力，保证用户数据在勒索攻击前做好充分准备'),
          },
          {
            title: i18n_t('及时有效还原——事后备份恢复'),
            icon: 'advanceGuide-icon-5',
            text: i18n_t('通过开启历史版本，进行多版本溯源恢复，及时对不同版本文件进行修复处理'),
          },
        ],
        btnText: i18n_t('开启防勒索能力'),
      },
    ];
    const { workbenchSteps } = sidebarGuideHandler();
    const { methods: guideMethods } = guideHandler();
    const methods = {
      goManage() {
        reporter.report('manager_new_guide_success', {
          success_count_type: 'manager_mission_four_control_center',
        });
        const { didAdmin } = store.getters.noviceGuidance;
        const { userRole } = store.getters;
        innerShow.value = false;
        if (userRole === RoleMap.User || userRole === RoleMap.TeamAdmin) {
          return;
        }
        nextTick(() => {
          const admin = [
            {
              id: 'spaceStatistics',
              title: i18n_t('这里进入/退出管理中心'),
              context: i18n_t('统一管理企业员工，企业资产及企业网盘空间。'),
              type: 'goAdmin',
              position: 'right-bottom',
            },
          ];
          if (!didAdmin?.didOpenManage) {
            startGuideSteps(admin);
            guideMethods.goAdminGuide('manage');
            ipc.emit(ipc.RENDERER_EVENTS_MAP.START_GUIDE);
          } else {
            dispatchRouter({
              name: 'spaceStatistics',
            });
          }
        });
      },
      reviewGuide() {
        innerShow.value = false;
        ipc.emit(ipc.RENDERER_EVENTS_MAP.START_GUIDE);
        nextTick(() => {
          startGuideSteps(workbenchSteps.value);
        });
      },
      onClickBtn(cardId: number) {
        guideMethods.reportFunctionGuide(cardId + 1, 'guide_dlg_click');
        innerShow.value = false;
        nextTick(() => {
          if (cardId === 2) {
            dispatchRouter({
              name: 'electronicSign',
            });
          } else if (cardId === 3) {
            if (IS_BROWSER) {
              // 浏览器下载桌面端
              const downloadUrlInBrowser = `${getOfficialWebsiteUrl()}/download`;
              dispatchRouter(downloadUrlInBrowser);
            } else {
              // pc端则跳转设置中心
              ipc.emit(ipc.RENDERER_EVENTS_MAP.SHOW_SETTING_DLG, {
                defaultPage: SettingTab.SECURITY,
              });
            }
          }
        });
      },
      clickVideo(section: IntroSection) {
        const tjdMap: any = {
          'advanceGuide-step-1': 'manager_mission_one_staff',
          'advanceGuide-step-2': 'manager_mission_two_assets',
          'advanceGuide-step-3': 'manager_mission_three_data',
        };
        if (section.icon in tjdMap) {
          reporter.report('manager_new_guide_success', {
            success_count_type: tjdMap[section.icon],
          });
        }
        if (IS_BROWSER) {
          // 浏览器在当前页面打开小窗口
          dispatchRouter(
            `${httpUrl.staticCDNUrl}/tools/videos/${section.id}.mp4`,
            'newWindow',
            'height=500,width=700,top=200,left=300',
          );
        } else {
          dispatchRouter(`${httpUrl.staticCDNUrl}/tools/videos/${section.id}.mp4`);
        }
        guideMethods.handlerAdminCard(0, true);
      },
    };
    onMounted(() => {
      if (IS_BROWSER && detailList.length > 3) {
        // 根据情况修改显示的文案
        detailList[3].btnText = i18n_t('下载桌面端体验');
      }
    });
    return {
      detailList,
      innerShow,
      ...guideMethods,
      ...methods,
    };
  },
});
